import { gql } from 'graphql-request'

export const CREATE_USER_HOST_TASK_SPECIAL = gql`
  mutation CREATE_USER_HOST_TASK_SPECIAL(
    $userHostTaskSpecialDefaultId: Int!
    $name: String!
    $description: String
    $specialTaskTypeQuality: SpecialTaskTypeQuality!
    $dateInitial: String!
    $dateFinal: String!
    $observation: String
    $continueNextWeek: Boolean!
  ) {
    createUserHostTaskSpecial(
      userHostTaskSpecialDefaultId: $userHostTaskSpecialDefaultId
      name: $name
      description: $description
      specialTaskTypeQuality: $specialTaskTypeQuality
      dateInitial: $dateInitial
      dateFinal: $dateFinal
      observation: $observation
      continueNextWeek: $continueNextWeek
    ) {
      error
      status
      data {
        id
        userHostTaskSpecialDefaultId
        userHostTaskSpecialDefault {
          id
          name
        }
        userId
        user {
          id
          username
          imgUser
        }
        name
        description
        specialTaskTypeQuality
        dateInitial
        dateFinal
        observation
        continueNextWeek
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_USER_HOST_TASK_SPECIAL = gql`
  mutation UPDATE_USER_HOST_TASK_SPECIAL(
    $userHostTaskSpecialId: Int!
    $userHostTaskSpecialDefaultId: Int
    $name: String
    $description: String
    $specialTaskTypeQuality: SpecialTaskTypeQuality
    $dateInitial: String
    $dateFinal: String
    $observation: String
    $continueNextWeek: Boolean
  ) {
    updateUserHostTaskSpecial(
      userHostTaskSpecialId: $userHostTaskSpecialId
      userHostTaskSpecialDefaultId: $userHostTaskSpecialDefaultId
      name: $name
      description: $description
      specialTaskTypeQuality: $specialTaskTypeQuality
      dateInitial: $dateInitial
      dateFinal: $dateFinal
      observation: $observation
      continueNextWeek: $continueNextWeek
    ) {
      error
      status
      data {
        id
        userHostTaskSpecialDefaultId
        userHostTaskSpecialDefault {
          id
          name
        }
        userId
        user {
          id
          username
          imgUser
        }
        name
        description
        specialTaskTypeQuality
        dateInitial
        dateFinal
        observation
        continueNextWeek
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_USER_HOST_TASK_SPECIAL = gql`
  query GET_USER_HOST_TASK_SPECIAL($userHostTaskSpecialId: Int!) {
    getUserHostTaskSpecial(userHostTaskSpecialId: $userHostTaskSpecialId) {
      error
      status
      data {
        id
        userHostTaskSpecialDefaultId
        userHostTaskSpecialDefault {
          id
          name
        }
        userId
        user {
          id
          username
          imgUser
        }
        name
        description
        specialTaskTypeQuality
        dateInitial
        dateFinal
        observation
        continueNextWeek
        createdAt
        updatedAt
      }
    }
  }
`
export const GET_USERS_HOSTS_TASKS_SPECIALS = gql`
  query GET_USERS_HOSTS_TASKS_SPECIALS(
    $take: Int
    $skip: Int
    $userHostTaskSpecialDefaultId: Int
    $userId: Int
    $name: String
    $description: String
    $specialTaskTypeQuality: SpecialTaskTypeQuality
    $typeFilterDate: TypeFilter
    $dateInitial: String
    $dateFinal: String
    $observation: String
    $continueNextWeek: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getUsersHostsTasksSpecials(
      take: $take
      skip: $skip
      userHostTaskSpecialDefaultId: $userHostTaskSpecialDefaultId
      userId: $userId
      name: $name
      description: $description
      specialTaskTypeQuality: $specialTaskTypeQuality
      typeFilterDate: $typeFilterDate
      dateInitial: $dateInitial
      dateFinal: $dateFinal
      observation: $observation
      continueNextWeek: $continueNextWeek
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        id
        userHostTaskSpecialDefaultId
        userHostTaskSpecialDefault {
          id
          name
        }
        userId
        user {
          id
          username
          imgUser
        }
        name
        description
        specialTaskTypeQuality
        dateInitial
        dateFinal
        observation
        continueNextWeek
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_USER_HOST_TASK_SPECIAL_FIRST = gql`
  query GET_USER_HOST_TASK_SPECIAL_FIRST(
    $id: Int
    $userHostTaskSpecialDefaultId: Int
    $userId: Int
    $name: String
    $description: String
    $specialTaskTypeQuality: SpecialTaskTypeQuality
    $typeFilterDate: TypeFilter
    $dateInitial: String
    $dateFinal: String
    $observation: String
    $continueNextWeek: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getUserHostTaskSpecialFirst(
      id: $id
      userHostTaskSpecialDefaultId: $userHostTaskSpecialDefaultId
      userId: $userId
      name: $name
      description: $description
      specialTaskTypeQuality: $specialTaskTypeQuality
      typeFilterDate: $typeFilterDate
      dateInitial: $dateInitial
      dateFinal: $dateFinal
      observation: $observation
      continueNextWeek: $continueNextWeek
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      data {
        id
        userHostTaskSpecialDefaultId
        userHostTaskSpecialDefault {
          id
          name
        }
        userId
        user {
          id
          username
          imgUser
        }
        name
        description
        specialTaskTypeQuality
        dateInitial
        dateFinal
        observation
        continueNextWeek
        createdAt
        updatedAt
      }
    }
  }
`
